/**
*
* RedFooter
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import Wrapper from 'components/Templates/dynamics/Wrapper';

import defaultTextValues from './defaultTextValues';

class RedFooter extends React.Component {


  render() {

    const {
      commonData,
      openEditor,
      commonProps,
      defaultValues
    } = this.props;

    const {
      twitterAccount,
      facebookAccount,
      linkedinAccount,
      instagramAccount,
      slackAccount,
    } = defaultValues;

    return (
      <Wrapper
        {...commonProps}
        
        typeOfStyle={'wrapper'}
        editorData={
          {
            editorType: 'wrapper',
            ...commonData
          }
        }
      >
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'wrapperWithMargin'}
          editorData={
            {
              editorType: 'wrapperWithMargin',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'subsectionWrapper'}
            editorData={
              {
                editorType: 'subsectionWrapper',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'subsectionOne'}
              editorData={
                {
                  editorType: 'subsectionOne',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'subsectionOneTitle'}
                type={'text'}
                defaultValues={defaultTextValues}
                editorData={
                  {
                    editorType: 'subsectionOneTitle',
                    ...commonData
                  }
                }
              />
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'subsectionOneContent'}
                type={'text'}
                defaultValues={defaultTextValues}
                editorData={
                  {
                    editorType: 'subsectionOneContent',
                    ...commonData
                  }
                }
             />
            </Wrapper>
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'subsectionTwo'}
              editorData={
                {
                  editorType: 'subsectionTwo',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'subsectionTwoTitle'}
                type={'text'}
                defaultValues={defaultTextValues}
                editorData={
                  {
                    editorType: 'subsectionTwoTitle',
                    ...commonData
                  }
                }
              />
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'subsectionTwoContent'}
                type={'text'}
                defaultValues={defaultTextValues}
                editorData={
                  {
                    editorType: 'subsectionTwoContent',
                    ...commonData
                  }
                }
              />
            </Wrapper>
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'subsectionThree'}
              editorData={
                {
                  editorType: 'subsectionThree',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'subsectionThreeTitle'}
                type={'text'}
                defaultValues={defaultTextValues}
                editorData={
                  {
                    editorType: 'subsectionThreeTitle',
                    ...commonData
                  }
                }
              />
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'subsectionThreeContent'}
                type={'text'}
                defaultValues={defaultTextValues}
                editorData={
                  {
                    editorType: 'subsectionThreeContent',
                    ...commonData
                  }
                }
              />
            </Wrapper>
          </Wrapper>
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'bottomlineWrapper'}
            editorData={
              {
                editorType: 'bottomlineWrapper',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'createdWith'}
              href={'https://www.acara.io'}
              target={'_blank'}
              editorData={
                {
                  editorType: 'createdWith',
                  ...commonData
                }
              }
            >
              {'made with Acara'}
            </Wrapper>
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'socialIconsWrapper'}
              editorData={
              {
                editorType: 'socialIconsWrapper',
                ...commonData
              }
            }
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'socialIconsTitle'}
                type={'text'}
                defaultValues={defaultTextValues}
                editorData={
                  {
                    editorType: 'socialIconsTitle',
                    ...commonData
                  }
                }
              />
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'socialIconsContent'}
                editorData={
                  {
                    editorType: 'socialIconsContent',
                    ...commonData
                  }
                }
              >
                <Wrapper
                  {...commonProps}
                  typeOfStyle={'footerLinkedinIcon'}
                  href={linkedinAccount}
                  
                  target={'_blank'}
                  editorData={
                    {
                      editorType: 'footerLinkedinIcon',
                      ...commonData
                    }
                  }
                />


                <Wrapper
                  {...commonProps}
                  typeOfStyle={'footerFacebookIcon'}
                  href={facebookAccount}
                  
                  target={'_blank'}
                  editorData={
                    {
                      editorType: 'footerFacebookIcon',
                      ...commonData
                    }
                  }
                />


                <Wrapper
                  {...commonProps}
                  typeOfStyle={'footerInstagramIcon'}
                  href={instagramAccount}
                  
                  target={'_blank'}
                  editorData={
                    {
                      editorType: 'footerInstagramIcon',
                      ...commonData
                    }
                  }
                />

                  <Wrapper
                    {...commonProps}
                    typeOfStyle={'footerTwitterIcon'}
                    href={twitterAccount}
                    
                    target={'_blank'}
                    editorData={
                      {
                        editorType: 'footerTwitterIcon',
                        ...commonData
                      }
                    }
                  />

                  <Wrapper
                    {...commonProps}
                    typeOfStyle={'footerSlackIcon'}
                    
                    href={slackAccount}
                    editorData={
                      {
                        editorType: 'footerSlackIcon',
                        ...commonData
                      }
                    }
                  />   
              </Wrapper>
            </Wrapper>
          </Wrapper>
        </Wrapper>
      </Wrapper>
    );


  }
}

RedFooter.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
};

export default RedFooter;
